import { VAutocomplete } from 'vuetify/lib/components/index.mjs';

export const autocompleteDefaults: Partial<VAutocomplete> = {
  variant: 'solo',
  flat: true,
  singleLine: true,
};
